import React from "react";
import "./TouchBalloons.scss";
import { TouchBalloon } from "./TouchBalloon/TouchBalloon";

interface IProps {
    onClick: () => void;
    show: boolean;
}

export function TouchBalloons(props: IProps) {
    return (
        <div className={`touch-balloons-wrapper ${props.show ? 'show' : ''}`} onClick={props.onClick}>
            <div className="touch-balloons-container">
                <div className="single-balloon">
                    <TouchBalloon />
                </div>
                <div className="single-balloon">
                    <TouchBalloon />
                </div>
                <div className="single-balloon">
                    <TouchBalloon />
                </div>
                <div className="single-balloon">
                    <TouchBalloon />
                </div>
            </div>
        </div>
    )
}
